import Reactotron from "reactotron-react-js"

type Tron = Partial<ReturnType<typeof Reactotron.configure>> & {
  trackMstNode?: ((node?: any | undefined) => any) | undefined
}

export const reactotron: Tron = process.env.NODE_ENV === "development"
  ? Reactotron.configure({}).connect()
  : {}
